import { serializable, primitive, date, object, identifier } from 'serializr';
import { SynchronizableData } from 'stores/Persistable';

export default class Department {
  @serializable(identifier())
  id?: number;
  @serializable(primitive())
  ihsiCode?: string;
  @serializable(primitive())
  name?: string;
}

export class DepartmentSynchronizableData implements SynchronizableData<Department> {
  constructor(isSynchronized: boolean, data: Department) {
    this.isSynchronized = isSynchronized;
    this.data = data;
    if (isSynchronized) {
      this.lastSynchronizedOn = new Date();
    }
  }

  @serializable
  isSynchronized: boolean;

  @serializable(date())
  lastSynchronizedOn?: Date;

  @serializable(date())
  storedAt?: Date;

  @serializable(object(Department))
  data: Department;
}
